'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperInstance } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import './index.scss';

export default function IndexClient({ list, prefixCls, id }: { list: any[]; prefixCls: string; id: string }) {
    const [active, setActive] = useState(0);
    const swiperRef = useRef<SwiperInstance | null>(null);

    useEffect(() => {
        setActive((a) => (list.length && a >= list.length ? 0 : a));
    }, [list.length]);

    const goToSlide = (i: number) => {
        setActive(i);
        const s = swiperRef.current;
        if (!s) return;
        if (s.params.loop) {
            s.slideToLoop(i);
        } else {
            s.slideTo(i);
        }
    };

    return (
        <div className={`${prefixCls}-items ${prefixCls}-items-${id}`}>
            <div className={`${prefixCls}-item-info`}>
                <h3 className={`${prefixCls}-item-title`}>{list[active]?.title}</h3>
                <p className={`${prefixCls}-item-desc`}>{list[active]?.desc}</p>
            </div>
            <div className={`${prefixCls}-mobile-gallery`}>
                <Swiper
                    className={`${prefixCls}-swiper`}
                    spaceBetween={16}
                    slidesPerView="auto"
                    centeredSlides
                    loop={list.length > 1}
                    onSwiper={(s) => {
                        swiperRef.current = s;
                    }}
                    onSlideChange={(s) => {
                        setActive(s.realIndex);
                    }}
                >
                    {list.map((item: any, i: number) => {
                        const { pc } = item;
                        return (
                            <SwiperSlide
                                className={`${prefixCls}-swiper-slide ${prefixCls}-item`}
                                key={i}
                                onClick={() => goToSlide(i)}
                                style={{ backgroundColor: active === i ? 'white' : '#CFD0D2' }}
                            >
                                <EcoImg className={`${prefixCls}-item-img`} pc={pc} pad={pc} h5={pc} alt={''} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className={`${prefixCls}-pagination`} role="tablist" aria-label="轮播进度">
                    {list.map((_, i) => (
                        <button
                            key={i}
                            type="button"
                            role="tab"
                            aria-label={`Slide ${i + 1}`}
                            aria-selected={i === active}
                            className={`${prefixCls}-pagination-segment ${i === active ? 'is-active' : ''}`}
                            onClick={() => goToSlide(i)}
                        />
                    ))}
                </div>
            </div>

            <div className={`${prefixCls}-pc-imgs`}>
                {list.map((item: any, i: number) => {
                    const { pc, h5 } = item;
                    return (
                        <div
                            className={`${prefixCls}-item`}
                            key={i}
                            onClick={() => {
                                setActive(i);
                            }}
                            style={{ backgroundColor: active === i ? 'white' : '#CFD0D2' }}
                        >
                            <EcoImg className={`${prefixCls}-item-img`} pc={pc} pad={pc} h5={h5 || pc} alt={''} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
